import type { ReduxStateType } from 'Core/store';

const showSelector = (state: ReduxStateType): ReduxStateType['show'] => state.show;

export const infiniteScrollLoadingSelector = (state: ReduxStateType): boolean =>
  showSelector(state).infiniteScrollLoading;
export const facetsLoadingSelector = (state: ReduxStateType): boolean => showSelector(state).facetsLoading;
export const resultsLoadingSelector = (state: ReduxStateType): boolean => showSelector(state).resultsLoading;
export const viewSelector = (state: ReduxStateType): string => showSelector(state).view;
